export function sizeSliderOptions(min, max, step) {
  const start = Math.ceil(min / step) * step;
  const values = new Set([min]);

  for (let value = start; value < max; value += step) {
    values.add(value);
  }

  values.add(max);

  return [...values].map((value) => ({ label: `${value} GiB`, value }));
}
